import type { OneTimeExpenseCategory } from "../../api/types";

export const ONE_TIME_CATEGORY_LABEL: Record<OneTimeExpenseCategory, string> = {
  REPAIR: "Repair",
  EQUIPMENT: "Equipment",
  SUPPLIES: "Supplies",
  MARKETING: "Marketing",
  PROFESSIONAL_FEES: "Professional fees",
  LICENCE_FEES: "Licence fees",
  OTHER: "Other",
};

export const ONE_TIME_CATEGORIES = Object.keys(
  ONE_TIME_CATEGORY_LABEL,
) as OneTimeExpenseCategory[];
